[].slice.call(document.querySelectorAll('#hero .start-button, .categories-button, .locations-button')).forEach(function(button) {
	button.addEventListener('click', function() {
		var list = this.parentNode.querySelector('ul');

		this.classList.toggle('open');

		list.setAttribute('aria-expanded', (list.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

		Velocity(list, (window.getComputedStyle(list).display == 'block' ? 'slideUp' : 'slideDown'), {duration: 150});
	});
});

body.addEventListener('click', function(e) {
	var open = document.querySelector('#hero .start-button.open, .categories-button.open, .locations-button.open');

	if(open)
		if(open !== this && !open.parentNode.contains(e.target))
			closeCustomDropdown(open);
});

window.closeCustomDropdown = function closeDropDown(button) {
	var list = button.parentNode.querySelector('ul');

	button.classList.remove('open');
	list.setAttribute('aria-expanded', 'false');
	Velocity(list, 'slideUp', {duration: 150});
};